import Colors from '@root/gatsby-contentful-core/src/utils/colors';
import { P2 } from '@root/gatsby-contentful-core/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function MapColorScale() {
  return (
    <div css={styles.mapColorScaleContainer}>
      <P2 css={styles.scaleTitle}>% change</P2>
      <ul css={styles.mapColorScale}>
        <li css={styles.colorBlock}>
          <div
            className={'color-swatch'}
            css={styles.colorBlock}
          />
          <P2 css={styles.colorLabel}>Not measured</P2>
        </li>
        <li css={styles.colorBlock}>
          <div
            className={'color-swatch'}
            css={styles.colorSwatch}
          />
          <P2 css={styles.colorLabel}>&gt;0%</P2>
        </li>
        <li css={styles.colorBlock}>
          <div
            className={'color-swatch'}
            css={styles.colorSwatch}
          />
          <P2 css={styles.colorLabel}>-1-14%</P2>
        </li>
        <li css={styles.colorBlock}>
          <div
            className={'color-swatch'}
            css={styles.colorSwatch}
          />
          <P2 css={styles.colorLabel}>-15-19%</P2>
        </li>
        <li css={styles.colorBlock}>
          <div
            className={'color-swatch'}
            css={styles.colorSwatch}
          />
          <P2 css={styles.colorLabel}>-20-24%</P2>
        </li>
        <li css={styles.colorBlock}>
          <div
            className={'color-swatch'}
            css={styles.colorSwatch}
          />
          <P2 css={styles.colorLabel}>-25-29%</P2>
        </li>
        <li css={styles.colorBlock}>
          <div
            className={'color-swatch'}
            css={styles.colorSwatch}
          />
          <P2 css={styles.colorLabel}>&lt;-30%</P2>
        </li>
      </ul>
    </div>
  );
}

const styles = StyleSheet.create({
  mapColorScaleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    marginTop: 50,
    width: '100%',
    maxWidth: 640,
  },
  scaleTitle: {
    marginBottom: 10,
    color: Colors.nearBlack(),
    fontSize: 12,
    fontWeight: 600,
    textAlign: 'center',
  },
  mapColorScale: {
    display: 'flex',
    width: '100%',
    listStyle: 'none',
  },
  colorBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 1 auto',
    margin: 0,
    '& .color-swatch': {
      width: '100%',
      height: 14,
      marginBottom: 10,
      backgroundColor: Colors.rootOrange(),
    },
    '&:nth-of-type(1) .color-swatch': {
      marginRight: 8,
      backgroundColor: Colors.grayLight(),
    },
    '&:nth-of-type(2) .color-swatch': {
      backgroundColor: Colors.lightBlue(),
    },
    '&:nth-of-type(3) .color-swatch': {
      opacity: .1,
    },
    '&:nth-of-type(4) .color-swatch': {
      opacity: .25,
    },
    '&:nth-of-type(5) .color-swatch': {
      opacity: .55,
    },
    '&:nth-of-type(6) .color-swatch': {
      opacity: .75,
    },
  },
  colorLabel: {
    fontSize: 12,
  },
});
